import Icon from '../../../atoms/icon'
import React, { useEffect, useState } from 'react'

const cashPlusInfo = {
  copy: {
    success: {
      title: 'We’re pleased to confirm that Cashplus Bank have approved your application.',
      body: '<div>You will also receive these details in an email from Cashplus Bank within 1 working day – please ensure that you monitor your email inbox, including your Junk Inbox for this. <br/>  <br/> You will also receive your card in the post within 3-5 working days at your home address. To activate the account, you simply need to ensure that you pay funds into the bank account within 60 days of your application.</div>',
    },
  },
  apiEndpoint: '/cashplus/application',
  identifier: 'cashPlusSession',
}

const ResultsCard = ({ status }) => {
  const { __FS_API_URL__ } = global
  const apiPath: string = __FS_API_URL__ || 'https://www.money.co.uk/api'

  const [resultsStatus, setResultsStatus] = useState(status)
  const [loading, setLoading] = useState(!status)

  useEffect(() => {
    if (!resultsStatus) {
      setLoading(true)
      fetch(
        `${apiPath}${cashPlusInfo.apiEndpoint}?sessionId=${sessionStorage.getItem(
          cashPlusInfo.identifier,
        )}&brand=money`,
      ).then(async (d) => {
        const res = await d.json()
        if (d.status === 200) {
          setResultsStatus(res.status)
          setLoading(false)
        }
      })
    }
  }, [])
  return loading ? (
    <div className='ResultsCard__loadingSkeleton' />
  ) : (
    <div className='ResultsCard'>
      <div className='ResultsCard__title'>
        {status === 'success' && (
          <Icon glyph='tick-circle' size={24} desktopSize={48} fill='#924a8b' />
        )}
        <h2>{cashPlusInfo.copy[resultsStatus]?.title}</h2>
      </div>

      <div className='ResultsCard__details'>
        {resultsStatus === 'success' && (
          <div className='ResultsCard__details__success'>
            <div>
              <strong>Application Reference</strong>: xxxxxx
            </div>
            <div>Application Reference: xxxxxx</div>
            <div>Application Reference: xxxxxx</div>
          </div>
        )}
        <div
          className='ResultsCard__details__body'
          dangerouslySetInnerHTML={{ __html: cashPlusInfo.copy[resultsStatus]?.body }}
        />
      </div>
    </div>
  )
}

export default ResultsCard
